const styles = ({ BREAKPOINTS }) => ({
  container: {
    background: '#333',
    height: 'calc(100vh - 120px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      height: 'calc(100vh - 140px)'
    }
  },
  inner: {
    height: '100%',
    overflow: 'scroll',
    display: 'flex'
  },
  page: {
    margin: '40px auto 100px',
    width: '100%',
    maxWidth: '900px',
    padding: '0 20px',
    color: '#fff'
  },
  spinner: {
    margin: '140px auto'
  },
  head: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '22px'
  }
})

export default styles
